export default __webpack_public_path__ + "static/innovationAutomation-2988600aefb99251f614b9f8569662c8.svg";